import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import logo from './logo.svg';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import OurTeam from './pages/OurTeam';
import GetAQuote from './pages/GetAQuote';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';

import WebDesigning from './pages/WebDesigning';
import WebDevelopment from './pages/WebDevelopment';
import EcommerceSolutions from './pages/EcommerceSolutions';
import MobileAppDevelopment from './pages/MobileAppDevelopment';
import SeoService from './pages/SeoService';
import TestingAndSupport from './pages/TestingAndSupport';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us.html" element={<AboutUs />} />
        <Route path="/services.html" element={<Services />} />
        <Route path="/portfolio.html" element={<Portfolio />} />
        <Route path="/ourteam.html" element={<OurTeam />} />
        <Route path="/get-a-quote.html" element={<GetAQuote />} />
        <Route path="/contact-us.html" element={<ContactUs />} />
        <Route path="/web-designing.html" element={<WebDesigning />} />
        <Route path="/web-development.html" element={<WebDevelopment />} />
        <Route path="/e-commerce-solutions.html" element={<EcommerceSolutions />} />
        <Route path="/mobile-app-development.html" element={<MobileAppDevelopment />} />
        <Route path="/seo-service.html" element={<SeoService />} />
        <Route path="/testing-and-support.html" element={<TestingAndSupport />} />
      </Routes>
    </Router>
  );
}
export default App;